

























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppFormCheckbox from '@/components/AppFormCheckbox.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import { IInsuredLifeInput } from '@/modules/Insured/interfaces/insured-form'
import { duiValues, healthValues } from '@/modules/Insured/helpers/insured'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppFormCheckbox,
    AppDatePicker,
    AppTextarea
  }
})
export default class InsuredFormLife extends Vue {
  @Prop({ type: Object as () => IInsuredLifeInput }) value!: IInsuredLifeInput

  duiValues = duiValues
  healthValues = healthValues

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
